import GridImplementation from './implementation/GridImplementation';
var GridComponent = GridImplementation;
export default GridComponent;
//# sourceMappingURL=GridComponent.js.map